import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector, editEventVenueBlock } from "Bands/state";
import { useEventContext, useVenueBlockContext } from "Bands/contexts";
import { API_ENDPOINTS } from "shared/constants";
import { BAND_ACTIONS } from "Bands/types";

export const useEditVenueBlock = (blockId?: string) => {
  const dispatch = useDispatch();
  const { blockTitle, venueId, stageId, capacityId } = useVenueBlockContext();
  const { eventId } = useEventContext();

  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.editEventVenueBlock)
  );

  const handleSubmit = () => {
    if (!blockTitle || !eventId || !venueId || !blockId) return null;

    const cleanData = {
      title: blockTitle,
      event: API_ENDPOINTS.EVENT(eventId),
      venue: API_ENDPOINTS.VENUE(venueId),
      stage: stageId ? API_ENDPOINTS.STAGE(stageId) : null,
      stageCapacity: capacityId
        ? API_ENDPOINTS.STAGE_CAPACITY(capacityId)
        : null,
    };

    dispatch(editEventVenueBlock({ id: blockId, data: cleanData }));
  };

  return {
    handleSubmit,
    apiMeta,
  };
};
